var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"utlz-product-block utlz-reset"},[(_vm.products.length > 0)?_c('utlz-product-carousel',{attrs:{"products":_vm.products,"blockSize":2}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }